<template>
  <div class="publisher-dialog">
    <portal to="base-modal">
      <base-modal @closed_requested="close_publisher_dialog">
        <h3 v-if="publisher.persisted"> Update publisher</h3>
        <h3 v-else>New Publisher</h3>

        <form @submit.prevent="save_publisher" ref="form">
          <div v-if="errors" class="callout alert">
            <h5>Error</h5>
            <p v-for="error in errors">{{ error }}</p>
            <button @click.stop="errors = null" class="close-button" aria-label="Dismiss alert" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <fieldset>
            <label v-if="publisher.persisted">
              ID:
              <input type="text"
                     v-model="publisher.id"
                     :disabled="true">
            </label>
            <label>
              Titel:
              <input type="text"
                     v-model="publisher.title"
                     placeholder="Titel">
            </label>
          </fieldset>

          <div>
            <a v-if="publisher.persisted"
               @click.stop.prevent="delete_publisher"
               :class="disabled_button_class"
               class="publisher-dialog--button--alert">
              <i class="fi-alert"></i>
              Löschen ...
            </a>
            <a @click="close_publisher_dialog" class="publisher-dialog--button--abort">
              <i class="fi-x"></i>
              Abbrechen
            </a>
            <button v-if="publisher_configured"
                    :class="disabled_button_class">
              <i class="fi-save"></i>
              <span v-if="publisher.persisted">Update publisher</span>
              <span v-else>Add publisher</span>
            </button>
          </div>
        </form>
      </base-modal>
    </portal>
  </div>
</template>

<script>
import "./publisher-dialog.scss"
import BaseModal from "../base-modal/base-modal-app"
import axios from "axios"

export default {
  name: "publisher-dialog",
  props: {
    publisher: {
      required: false,
      default() {
        return {
          id: null,
          title: null,
          persisted: false,
        }
      },
    },
  },
  components: {
    BaseModal,
  },
  data() {
    return {
      loading: false,
      errors: null,
    }
  },
  methods: {
    save_publisher() {
      if (!this.publisher_configured) return
      if (this.loading) return

      this.loading = true
      this.errors = null

      if (this.publisher.persisted) {
        axios({
          method: 'post',
          url: `/publishers/${this.publisher.id}/update`,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          data: {
            id: this.publisher.id,
            title: this.publisher.title,
          },
        }).then((_response) => {
          this.loading = false
          this.close_publisher_dialog()
        }).catch(error => {
          this.loading = false
          this.errors = error.response.data.errors.map(error => error.title)
          console.log("ERROR", error.response.data)
          alert("Error saving publisher")
        })
      } else {
        axios({
          method: 'post',
          url: `/publishers/register`,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          data: {
            id: this.publisher.id,
            title: this.publisher.title,
          },
        }).then((_response) => {
          this.loading = false
          this.close_publisher_dialog()
        }).catch(error => {
          this.loading = false
          this.errors = error.response.data.errors.map(error => error.title)
          console.log("ERROR", error.response.data)
          alert("Error saving publisher")
        })
      }
    },
    delete_publisher() {
      let confirmation = confirm("Do you really want to delete the publisher?")
      if (!confirmation) return
      axios({
        method: 'delete',
        url: `/publishers/${this.publisher.id}/delete`,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      }).then((_response) => {
        this.loading = false
        this.close_publisher_dialog()
      }).catch(error => {
        this.loading = false
        this.errors = error.response.data.errors.map(error => error.title)
        console.log("ERROR", error.response.data)
        alert("Error deleting publisher")
      })
    },
    close_publisher_dialog() {
      this.$emit("closed_requested")
    },
  },
  computed: {
    publisher_configured() {
      if (!this.publisher.title) return false
      return true
    },
    disabled_button_class() {
      if (this.publisher_configured) {
        return "publisher-dialog--button"
      } else {
        return "publisher-dialog--disabled"
      }
    },
  },
}
</script>
